import React from 'react'
import Box from '@material-ui/core/Box'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Container from 'components/program-marketing/container'
import { Coach } from './coach'
import { Location } from './location'
import { Information } from './information'
import { WhatsIncluded } from './whats-included'

export const LocationSection = ({
  location,
  description,
  viewContactCoach,
  viewProgramInformation,
  requirements,
}) => {
  const hasInformation =
    !!location.links.facebook || !!location.links.instagram || !!description
  const hasRequirements = requirements?.length

  return (
    <Container color="white">
      <Box mb={2}>
        <Typography variant="h3" color="secondary">
          Location
        </Typography>
      </Box>
      <Box mb={4}>
        <Typography variant="h2">{location.name}</Typography>
      </Box>
      <Grid
        container
        direction="row"
        alignItems="stretch"
        justify="flex-start"
        spacing={4}
      >
        <Grid item container sm={12} md={6}>
          <Coach coach={location.coach} viewContactCoach={viewContactCoach} />
        </Grid>
        <Grid item container sm={12} md={6}>
          <Location location={location} />
        </Grid>
        {hasInformation && (
          <Grid item container sm={12} md={6}>
            <Information
              links={location.links}
              description={description}
              viewProgramInformation={viewProgramInformation}
            />
          </Grid>
        )}
        {hasRequirements && (
          <Grid item container sm={12} md={6}>
            <WhatsIncluded requirements={requirements} />
          </Grid>
        )}
      </Grid>
    </Container>
  )
}
